import React from 'react'
import { withRouter, Link } from 'react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { selectUrl } from '../../../store/site'
import { selectCurrentFundraisingPage } from '../../../store/fundraisingPage'
import { clearSession, selectPage, selectUser } from '../../../store/session'
import { selectCustomSupporterPagePresent } from '../../../store/customSupporterPages'

import SingleSignOnLink from 'supporticon/components/single-sign-on-link'

const LinkHandler = ({
  clearSession,
  currentPage,
  linkType,
  location = {},
  hasCustomSupporterPages,
  onClick,
  page = {},
  params,
  router,
  routes,
  siteUrl,
  user = {},
  to,
  ...props
}) => {
  const isButton = () => !to && onClick
  const isExternalLink = () => to && /^((ftp|http|https):\/\/)?(www\.)?[-a-zA-Z0-9@:;%._+~#=]{2,256}\.[a-z]{2,24}\b([-a-zA-Z0-9@:;%_+.,~#?&//=]*)$/.test(to)
  const isMailtoLink = () => to && to.indexOf('mailto') === 0
  const isAnchorLink = () => to && to.replace('/', '').indexOf('#') === 0
  const isQueryParam = () => to && to.indexOf('?') === 0

  const isCurrent = to === location.pathname || to === `${siteUrl}${location.pathname}`

  if (linkType === 'login' && user.token) {
    return <button {...props} onClick={clearSession}>Logout</button>
  }

  if (linkType === 'signup' && page.id) {
    if (hasCustomSupporterPages) {
      return <Link {...props} onClick={onClick} to={`/fundraising/${page.slug}`}>View Page</Link>
    } else {
      return <SingleSignOnLink authType={user.authType} label='View Page' token={user.token} url={page.url} target='_blank' {...props} />
    }
  }

  if (linkType === 'donate' && currentPage) {
    return <a {...props} href={currentPage.donationUrl} target='_blank' />
  }

  if (isButton()) {
    return <button onClick={onClick} {...props} />
  }

  if (isExternalLink()) {
    if (to.indexOf(siteUrl) > -1) {
      return <a {...props} aria-current={isCurrent} href={to} />
    }

    if (siteUrl.indexOf(to) > -1) {
      const href = to.replace(siteUrl, '') || '/'
      return <Link onClick={onClick} to={href} {...props} />
    }

    return <a {...props} href={to} target='_blank' />
  }

  if (isMailtoLink()) {
    return <a href={to} {...props} />
  }

  if (isAnchorLink()) {
    return <a href={to} onClick={onClick} {...props} />
  }

  if (isQueryParam()) {
    return <Link onClick={onClick} to={`${location.pathname}${to}`} aria-current={isCurrent} {...props} />
  }

  return <Link onClick={onClick} to={to} aria-current={isCurrent} {...props} />
}

const mapState = (state, props) => ({
  ...selectCustomSupporterPagePresent(state),
  currentPage: selectCurrentFundraisingPage(state, props),
  page: selectPage(state),
  siteUrl: selectUrl(state),
  user: selectUser(state)
})

const mapDispatch = { clearSession }

export default compose(
  withRouter,
  connect(mapState, mapDispatch)
)(LinkHandler)
